import type { GetPrebidUserIds, PrebidIdPartnerConfig } from "./IdPartners";

// TODO: Get current platform and set the correct publisherId once we're launching on other platforms
// Maybe just move tot the part of the config that is platform specific
// const publisherIds = {
//   gamefaqs: '79973',
//   gamespot: '79973',
//   comicvine: '79973',
//   f2: '79968',
//   'ucp-desktop': '79968',
//   'ucp-mobile': '79968',
//   tvguide: '79974',
//   giantbomb: '85122',
//   metacritic: '85123',
//   'metacritic-neutron': '85123',
//   fanatical: '85124',
//   sports: '85125',
// };

/**
 * @see https://docs.prebid.org/dev-docs/modules/userid-submodules/liveintent.html
 */

declare global {
  interface Window {
    liModuleEnabled?: boolean;
  }
}

export const liveIntentConnectedIdPartner: GetPrebidUserIds = (
  config: PrebidIdPartnerConfig,
) => {
  if (!config.icLiveIntentConnectedId) {
    return;
  }

  // TODO: Once we have more than 1 platform, this should be updated
  // const publisherId = publisherIds[window.ads?.config?.site];
  const publisherId = "79968";

  return {
    name: "liveIntentId",
    params: {
      publisherId,
      requestedAttributesOverrides: {
        uid2: true,
        bidswitch: true,
        medianet: true,
        magnite: true,
        pubmatic: true,
        index: true,
        openx: true,
        thetradedesk: true,
        sovrn: true,
      },
      ajaxTimeout: 1000,
      liCollectConfig: {
        fpiStorageStrategy: "ls",
        fpiExpirationDays: 730,
      },
    },
    storage: {
      name: "__tamLIResolveResult",
      type: "html5",
      expires: 1,
    },
  };
};
